import React from "react";

import { ExpandMore } from "@mui/icons-material";
import { Autocomplete, AutocompleteProps } from "@mui/material";

export const IgAutocomplete = (
  props: AutocompleteProps<any, any, any, any>
) => {
  return (
    <Autocomplete
      {...props}
      popupIcon={
        <ExpandMore
          fontSize={"small"}
          sx={{
            color: "#0000008a",
          }}
        />
      }
    />
  );
};
